import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import { Button } from 'components/shared';

export default styled((props) => <Button xs rounded {...props} />)`
  ${space};
`;
